import { OAuthPopup } from "@tasoskakour/react-use-oauth2";

export const OAuth2Callback = () => {
  return (
    <></>
  );
};